export default "__VITE_ASSET__DAoaj5OS__"